

import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import MobileMenu from './MobileMenu';

function Layout() {
  

  return (
    <div>
      <MobileMenu/>
      <Navbar/>
      <Outlet/>
      <Footer/>
    </div>
  );
}

export default Layout;
